import { useState, type FormEvent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Eingabefeld, Hinweis, Knopf, Laedt, Wortmarke } from '../ui';
import s from './seiten.module.css';

function zielAus(state: unknown): string {
  if (typeof state === 'object' && state !== null && 'von' in state) {
    const von = (state as { von: unknown }).von;
    if (typeof von === 'string' && von.startsWith('/') && !von.startsWith('//')) return von;
  }
  return '/';
}

export function Anmelden() {
  const { zustand, anmelden } = useAuth();
  const ort = useLocation();
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  if (zustand.status === 'laedt') return <Laedt />;
  if (zustand.status === 'angemeldet') return <Navigate to={zielAus(ort.state)} replace />;

  const absenden = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !passwort) {
      setFehler('Bitte gib E-Mail und Passwort ein.');
      return;
    }
    setLaeuft(true);
    setFehler(null);
    const ergebnis = await anmelden(email, passwort);
    setLaeuft(false);
    if (ergebnis.fehler) setFehler(ergebnis.fehler);
  };

  return (
    <main className={s.login}>
      <Wortmarke gross alsLink={false} />
      <div className={s.loginBild} aria-hidden="true">
        <img src="/illustrationen/leer-woche.webp" alt="" width={160} height={160} />
      </div>
      <h1 className={s.loginTitel}>Schön, dass du da bist</h1>
      <p className={s.loginText}>Melde dich an, dann geht es direkt weiter mit Rezepten, Woche und Einkauf.</p>

      <form className={s.formular} onSubmit={(e) => void absenden(e)} noValidate>
        {fehler && (
          <Hinweis art="fehler" titel="Anmelden hat nicht geklappt">
            {fehler}
          </Hinweis>
        )}
        <Eingabefeld
          label="E-Mail"
          type="email"
          name="email"
          autoComplete="username"
          inputMode="email"
          autoCapitalize="none"
          spellCheck={false}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Eingabefeld
          label="Passwort"
          type="password"
          name="passwort"
          autoComplete="current-password"
          value={passwort}
          onChange={(e) => setPasswort(e.target.value)}
          required
        />
        <div className={s.formularKnopf}>
          <Knopf type="submit" gross breit disabled={laeuft}>
            {laeuft ? 'Einen Moment …' : 'Anmelden'}
          </Knopf>
        </div>
      </form>
      <p className={s.fussnote}>Neue Konten gibt es nur per Einladung aus deiner Familie.</p>
    </main>
  );
}
